import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-chip',
  templateUrl: './chip.html',
  styleUrl: './chip.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class]': 'type()' },
})
export class ChipComponent {
  text = input.required<string>();
  type = input<'primary' | 'secondary'>('primary');
}
